import {
	UPDATE_OAT_FORM_PREF_REQUEST,
	UPDATE_OAT_FORM_PREF_SUCCESS,
	UPDATE_OAT_FORM_PREF_FAILURE
} from "../../../constants"

const initialState = {
	loading: false,
	data: null,
	error: null,
};

const oatFormPrefReducer = (state = initialState, action) => {
	switch (action.type) {
		case UPDATE_OAT_FORM_PREF_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
				data: null,
			};
		case UPDATE_OAT_FORM_PREF_SUCCESS:
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null,
			}
		case UPDATE_OAT_FORM_PREF_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload,
				data: null
			}
		default:
			return state;
	}
}
export default oatFormPrefReducer